import Grid from "../components/Grid/Grid";
import OshmaTable from "../components/Oshma/OshmaTable";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
const OshmaPage = () => {
  return (
    <StartingPageContent pageName="OSHMA">
      <OshmaTable></OshmaTable>
    </StartingPageContent>
  );
};

export default OshmaPage;
